function NumberFormat(number) {
  // Converte o valor para número, caso seja uma string
  const parsedNumber = parseFloat(number);

  // Verifica se o valor é um número válido e finito
  if (Number.isNaN(parsedNumber) || !Number.isFinite(parsedNumber)) {
    return '0,00'; // Retorna um valor padrão para NaN, Infinity, -Infinity
  }

  // Arredonda o número para 2 casas decimais e divide em parte inteira e fracionária
  const [whole, fraction] = (Math.round(parsedNumber * 100) / 100)
    .toFixed(2)
    .split('.');

  // Formata a parte inteira com separadores de milhar
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Retorna o número formatado
  return `${formattedWhole},${fraction}`;
}

export default NumberFormat;
